<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M-9.5,783.5l6.36,2.13v2.83L8.5,800.09v1.41H7.09l-11.64-11.64h-2.83L-9.5,783.5z M10.5,783.5l-2.12,6.37H5.55l-2.35,2.34
	l-1.41-1.41l2.34-2.34v-2.83L10.5,783.5z M-2.21,794.79l1.41,1.41l-5.29,5.29H-7.5v-1.41L-2.21,794.79z"/>
</svg>

</template>